module.exports = __webpack_public_path__ + "static/media/Reports.02c4125c.svg";